import { render, staticRenderFns } from "./Proccess.vue?vue&type=template&id=a73f850e&"
import script from "./Proccess.vue?vue&type=script&lang=js&"
export * from "./Proccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports